// Bilingual option data for the activity generator forms.
export const AGE_GROUPS = [
  { value: "Infants: Birth–12 months", en: "Infants: Birth–12 months", es: "Bebés: 0–12 meses" },
  { value: "Young Toddlers: 12–24 months", en: "Young Toddlers: 12–24 months", es: "Niños pequeños: 12–24 meses" },
  { value: "Older Toddlers: 24–36 months", en: "Older Toddlers: 24–36 months", es: "Niños mayores: 24–36 meses" },
  { value: "Preschool: 3 years", en: "Preschool: 3 years", es: "Preescolar: 3 años" },
  { value: "Preschool: 4 years", en: "Preschool: 4 years", es: "Preescolar: 4 años" },
  { value: "Pre-K: 4–5 years", en: "Pre-K: 4–5 years", es: "Pre-K: 4–5 años" },
  { value: "Mixed Age", en: "Mixed Age", es: "Edad mixta" },
];

export const LANGUAGES = [
  { value: "english", en: "English only", es: "Solo inglés" },
  { value: "spanish", en: "Spanish only", es: "Solo español" },
  { value: "bilingual", en: "English + Spanish", es: "Inglés + Español" },
];

export const THEMES = [
  { en: "Families", es: "Familias" },
  { en: "Transportation", es: "Transporte" },
  { en: "Community Helpers", es: "Ayudantes de la comunidad" },
  { en: "Animals", es: "Animales" },
  { en: "Weather", es: "El clima" },
  { en: "Seasons", es: "Las estaciones" },
  { en: "Plants", es: "Las plantas" },
  { en: "Food", es: "La comida" },
  { en: "Feelings", es: "Los sentimientos" },
  { en: "Friendship", es: "La amistad" },
  { en: "My Body", es: "Mi cuerpo" },
  { en: "Colors", es: "Los colores" },
  { en: "Shapes", es: "Las formas" },
  { en: "Numbers", es: "Los números" },
  { en: "Cultural Celebrations", es: "Celebraciones culturales" },
];

export const DOMAINS = [
  { value: "Language & Literacy", en: "Language & Literacy", es: "Lenguaje y Alfabetización" },
  { value: "Mathematics", en: "Mathematics", es: "Matemáticas" },
  { value: "Science", en: "Science", es: "Ciencias" },
  { value: "Social-Emotional Development", en: "Social-Emotional Development", es: "Desarrollo Socioemocional" },
  { value: "Approaches to Learning", en: "Approaches to Learning", es: "Enfoques del Aprendizaje" },
  { value: "Physical Development", en: "Physical Development", es: "Desarrollo Físico" },
  { value: "Creative Arts", en: "Creative Arts", es: "Artes Creativas" },
  { value: "Social Studies", en: "Social Studies", es: "Estudios Sociales" },
  { value: "Cognitive Development", en: "Cognitive Development", es: "Desarrollo Cognitivo" },
];

export const ACTIVITY_TYPES = [
  { value: "Circle Time", en: "Circle Time", es: "Tiempo en círculo" },
  { value: "Small Group", en: "Small Group", es: "Grupo pequeño" },
  { value: "Individual", en: "Individual", es: "Individual" },
  { value: "Learning Center", en: "Learning Center", es: "Centro de aprendizaje" },
  { value: "Outdoor", en: "Outdoor", es: "Al aire libre" },
  { value: "Music & Movement", en: "Music & Movement", es: "Música y movimiento" },
  { value: "Art", en: "Art", es: "Arte" },
  { value: "Sensory", en: "Sensory", es: "Sensorial" },
  { value: "Storytime", en: "Storytime", es: "Hora del cuento" },
  { value: "Transition", en: "Transition", es: "Transición" },
  { value: "Mealtime Conversation", en: "Mealtime Conversation", es: "Conversación en la comida" },
];

export const DURATIONS = [
  { value: "5 minutes", en: "5 minutes", es: "5 minutos" },
  { value: "10 minutes", en: "10 minutes", es: "10 minutos" },
  { value: "15 minutes", en: "15 minutes", es: "15 minutos" },
  { value: "20 minutes", en: "20 minutes", es: "20 minutos" },
  { value: "30 minutes", en: "30 minutes", es: "30 minutos" },
  { value: "Custom", en: "Custom", es: "Personalizado" },
];

export const label = (item, lang) => (lang === "es" ? item.es : item.en);
